import { Copy } from 'phosphor-react';

import CopyToClipboardButton from 'components/copy-icon';
import { ReportFilingDataInterface } from 'types/report';

function FileEmployeeReport({
  employeeFilingData
}: {
  employeeFilingData: ReportFilingDataInterface | null;
}): JSX.Element {
  return (
    <div className="pl-5 border-l-4 border-gray-200">
      <ul className="text-gray-900 text-base font-normal leading-8 mb-4 list-decimal ml-5">
        <li>
          Log into the&nbsp;
          <a
            href="https://pdr.calcivilrights.ca.gov/s/"
            className="btn-link"
            target="_blank"
            rel="noreferrer">
            CA Pay Data Reporting Portal
          </a>
          &nbsp;
        </li>
        <li>Start a submission (for the current reporting year, if filing for 2022) </li>
        <li>Select an employer, or create and select a new employer </li>
        <li>Select Create Payroll Employee Report </li>
        <li className="leading-7">
          Confirm employer info <br />
          Enter the following submission info in the corresponding boxes <br />
          <span className="font-semibold">Hint:</span> You can easily copy and paste each field by
          clicking the&nbsp;
          <Copy size="1.1rem" weight="bold" className="inline text-gray-800" />
          <div className="w-fit grid grid-cols-2 gap-6 mt-6 mb-4">
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Snapshot Period Beginning Date
              </label>
              <div className="input h-12 w-64 mb-0 relative" data-testid="snapshot-start-date">
                {employeeFilingData?.snapshotStartDate}
                <CopyToClipboardButton
                  text={employeeFilingData?.snapshotStartDate?.toString() ?? ''}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Snapshot Period End Date
              </label>
              <div className="input h-12 w-64 mb-0 relative" data-testid="snapshot-end-date">
                {employeeFilingData?.snapshotEndDate}
                <CopyToClipboardButton
                  text={employeeFilingData?.snapshotEndDate?.toString() ?? ''}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Total Number of US Establishments
              </label>
              <div className="input h-12 w-64 mb-0 relative" data-testid="us-establishments">
                {employeeFilingData?.USEstablishments}
                <CopyToClipboardButton
                  text={employeeFilingData?.USEstablishments?.toString() ?? ''}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Total Number of US Employees
              </label>
              <div className="input h-12 w-64 mb-0 relative" data-testid="us-employees">
                {employeeFilingData?.USEmployees}
                <CopyToClipboardButton text={employeeFilingData?.USEmployees?.toString() ?? ''} />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Total Number of CA Establishments
              </label>
              <div className="input h-12 w-64 mb-0 relative" data-testid="ca-establishments">
                {employeeFilingData?.CAEstablishments}
                <CopyToClipboardButton
                  text={employeeFilingData?.CAEstablishments?.toString() ?? ''}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-semibold text-gray-900 mb-2">
                Total Number of CA Employees
              </label>
              <div className="input h-12 w-64 mb-0 relative" data-testid="ca-employees">
                {employeeFilingData?.CAEmployees}
                <CopyToClipboardButton text={employeeFilingData?.CAEmployees?.toString() ?? ''} />
              </div>
            </div>
          </div>
        </li>
        <li>Click &quot;Import Data&quot; </li>
        <li>
          Certify and submit <br />
        </li>
      </ul>
      <div className="font-semibold">You&apos;re all done!</div>
    </div>
  );
}

export default FileEmployeeReport;
